var _rect, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterviewedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FE6A33"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5952_3804)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5952_3804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 11,
    width: 27,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.999 11.5024H36.999V37.5024H10.999V11.5024Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5952_3804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8516 30.6484V29.125C17.8516 27.4423 16.4874 26.0781 14.8047 26.0781C13.1219 26.0781 11.7578 27.4423 11.7578 29.125V36.7422H17.8516",
    stroke: "white",
    strokeWidth: 1.52344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6133 23.2852C18.6133 24.8277 17.3628 26.0781 15.8203 26.0781C14.2778 26.0781 13.0273 24.8277 13.0273 23.2852C13.0273 21.7426 14.2778 20.4922 15.8203 20.4922C17.3628 20.4922 18.6133 21.7426 18.6133 23.2852Z",
    stroke: "white",
    strokeWidth: 1.52344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1572 36.7412H16.8369V33.6943H31.1572V36.7412Z",
    stroke: "white",
    strokeWidth: 1.52344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8516 30.6484H20.8984C21.7398 30.6484 22.4219 31.3305 22.4219 32.1719C22.4219 33.0132 21.7398 33.6953 20.8984 33.6953H16.8359C15.7141 33.6953 14.8047 32.7859 14.8047 31.6641V30.6484",
    stroke: "white",
    strokeWidth: 1.52344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1406 30.6484V29.125C30.1406 27.4423 31.5048 26.0781 33.1875 26.0781C34.8702 26.0781 36.2344 27.4423 36.2344 29.125V36.7422H30.1406",
    stroke: "white",
    strokeWidth: 1.52344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3789 23.2852C29.3789 24.8277 30.6293 26.0781 32.1719 26.0781C33.7144 26.0781 34.9648 24.8277 34.9648 23.2852C34.9648 21.7426 33.7144 20.4922 32.1719 20.4922C30.6293 20.4922 29.3789 21.7426 29.3789 23.2852Z",
    stroke: "white",
    strokeWidth: 1.52344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1406 30.6484H27.0938C26.2524 30.6484 25.5703 31.3305 25.5703 32.1719C25.5703 33.0132 26.2524 33.6953 27.0938 33.6953H31.1562C32.2781 33.6953 33.1875 32.7859 33.1875 31.6641V30.6484",
    stroke: "white",
    strokeWidth: 1.52344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.918 13.2812V17.3438C18.918 17.9047 19.3727 18.3594 19.9336 18.3594H20.9492V20.3906L23.4883 18.3594H24.5039L27.043 20.3906V18.3594H28.0586C28.6195 18.3594 29.0742 17.9047 29.0742 17.3438V13.2812C29.0742 12.7203 28.6195 12.2656 28.0586 12.2656H19.9336C19.3727 12.2656 18.918 12.7203 18.918 13.2812Z",
    stroke: "white",
    strokeWidth: 1.52344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9648 15.3125H26.0273",
    stroke: "white",
    strokeWidth: 1.52344,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5952_3804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(11 11.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewedIcon);
export default __webpack_public_path__ + "static/media/interviewed_icon.5d1750c385ebe4447e4528776e9f7558.svg";
export { ForwardRef as ReactComponent };